// extracted by mini-css-extract-plugin
module.exports = {"button":"_de15b35","desktop":"_6db922a","single":"_ecdfbe5","sm":"_70250a4","multi":"_aeebbf8"};